import { removeCloudFrontPrefix } from 'services/util'
import type { CreateQuestionSavePayload } from './components/CreateQuestionModal'

export type ToolQuestionEntry = CreateQuestionSavePayload & {
    clientKey: string
}

export function newQuestionClientKey(): string {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID()
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

/** Strip UI-only keys before API / form submit. */
function chipImageToStoragePath(chip: string): string {
    const raw = String(chip ?? '').trim()
    if (!raw || raw.startsWith('data:')) return ''
    return removeCloudFrontPrefix(raw)
}

export function serializeToolQuestionsForApi(
    entries: ToolQuestionEntry[]
): CreateQuestionSavePayload[] {
    return entries.map(({ clientKey: _omit, ...question }) => ({
        ...question,
        chipImage: chipImageToStoragePath(question.chipImage),
    }))
}

/** Hydrate from tool detail (`questions` or common API aliases). */
export function parseToolQuestionsFromApi(
    tool: Record<string, unknown> | null | undefined
): ToolQuestionEntry[] {
    if (!tool) return []
    const raw =
        (tool as { questions?: unknown }).questions ??
        (tool as { Questions?: unknown }).Questions
    if (!Array.isArray(raw)) return []

    return raw.map((item: Record<string, unknown>) => ({
        clientKey: newQuestionClientKey(),
        question: String(item?.question ?? ''),
        description: String(item?.description ?? ''),
        chipImage: removeCloudFrontPrefix(
            String(
                item?.chipImage ??
                    (item as { chip_image?: string }).chip_image ??
                    ''
            ).trim()
        ),
        isMultiSelect:
            item?.isMultiSelect === 1 ||
            (item as { is_multi_select?: number }).is_multi_select === 1
                ? 1
                : 0,
        options: Array.isArray(item?.options)
            ? (item.options as Record<string, unknown>[]).map((o) => ({
                  label: String(o?.label ?? ''),
                  variable_name: String(
                      o?.variable_name ??
                          (o as { variableName?: string }).variableName ??
                          ''
                  ),
                  value: String(o?.value ?? ''),
              }))
            : [],
    }))
}
